import { UserTypes } from '../../SelfProvisioning/Constants/Constants'

export const LicenceTypeFieldValueMap: Record<string, string> = {
    None: 'NONE',
    'Akixi ONE': 'ONE',
    'Akixi BLF': 'PRESENCE',
    'Akixi Lite': 'LITE',
    'Akixi 1000': 'ONE_THOUSAND',
    'Akixi 2000': 'TWO_THOUSAND',
    Essentials: UserTypes.ESSENTIALS,
    Professional: UserTypes.PROFESSIONAL,
    Enterprise: UserTypes.ENTERPRISE,
    'Call Centre Agent': UserTypes.CALL_CENTRE_AGENT,
    'Call Centre Supervisor': UserTypes.CALL_CENTRE_SUPERVISOR
}

export enum TeamsLicenceTypes {
    NONE = 'None',
    EV = 'EV'
}
